import { render, staticRenderFns } from "./SkillReview.vue?vue&type=template&id=0e5045d4&scoped=true&"
import script from "./SkillReview.vue?vue&type=script&lang=js&"
export * from "./SkillReview.vue?vue&type=script&lang=js&"
import style0 from "./SkillReview.vue?vue&type=style&index=0&id=0e5045d4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e5045d4",
  null
  
)

export default component.exports